import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableSurchargeUI = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableSurchargeUI);
};
